import {Injectable} from '@angular/core';

@Injectable()
export class ComponentBackgroundService {
  private showStyle = false;

  constructor() {
  }

  setShowStyle(f) {
    this.showStyle = f;
  }

  getShowStyle() {
    return this.showStyle;
  }

}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/component-background.service.ts